export default "__VITE_ASSET__DNMplXIG__"